import { DataResponse } from "shared/models";
import { baseQuery } from "./baseQuery";
import { createApi } from "@reduxjs/toolkit/query/react";

export const threeDsService = createApi({
    reducerPath: "threeDsService",
    baseQuery: baseQuery,
    endpoints: (builder) => ({
        getByPartner: builder.query<DataResponse<any>, { partnerId: number}>({
            query: (params) => ({
                url: `/threeDs-setting/partner/${params?.partnerId}`,
                method: "GET",
                headers: {
                    PageName: "Partner ThreeDs",
                },
            }),
        }),
        saveByPartner: builder.mutation<DataResponse<any>, any>({
            query: ({ id, ...others }) => ({
                url: `/threeDs-setting/partner/${id}`,
                body: { ...others },
                method: "PUT",
                headers: {
                    PageName: "Partner ThreeDs",
                },
            }),
        }),
        getByMerchant: builder.query<DataResponse<any>, { merchantId: number}>({
            query: (params) => ({
                url: `/threeDs-setting/merchant/${params?.merchantId}`,
                method: "GET",
                headers: {
                    PageName: "Merchant ThreeDs",
                },
            }),
        }),
        saveByMerchant: builder.mutation<DataResponse<any>, any>({
            query: ({ id, ...others }) => ({
                url: `/threeDs-setting/merchant/${id}`,
                body: { ...others },
                method: "PUT",
                headers: {
                    PageName: "Merchant ThreeDs",
                },
            }),
        }),
    }),
});

export const {
    useGetByMerchantQuery,
    useLazyGetByMerchantQuery,
    useGetByPartnerQuery,
    useLazyGetByPartnerQuery,
    useSaveByMerchantMutation,
    useSaveByPartnerMutation,
} = threeDsService